export type Endpoints = {
  getPolicyPaymentInfo: string;
  initializePayment: string;
  getConfirmation: string;
  getTransactionStatus: string;
};

export enum Environments {
  dev1 = 'dev1',
  dev2 = 'dev2',
  dev = 'dev',
  qa1 = 'qa1',
  qa2 = 'qa2',
  qa = 'qa',
  uat1 = 'uat1',
  uat2 = 'uat2',
  uat = 'uat',
  prod = 'prod',
}

const endpointPath = {
  getPolicyPaymentInfo: '/policy-payment-info',
  initializePayment: '/manifest',
  getConfirmation: '/confirmation',
  getTransactionStatus: '/payment-status',
};

export const getEnvironmentFromHost = (hostname: string): Environments => {
  if (hostname.search('localhost') > -1) {
    return Environments.dev;
  } else {
    if (hostname.startsWith('appdev1') || hostname.startsWith('app.dev')) {
      return Environments.dev;
    } else if (hostname.startsWith('appqa1') || hostname.startsWith('app.qa')) {
      return Environments.qa;
    } else if (hostname.startsWith('appuat1') || hostname.startsWith('app.uat')) {
      return Environments.uat;
    } else if (hostname.startsWith('app.')) {
      return Environments.prod;
    } else {
      return Environments.dev;
    }
  }
};

export const getApiDomain = (env: Environments): string => {
  if (env === Environments.prod) {
    return `common.api.ace.aaa.com`;
  } else {
    return `common.api.${env}.ace.aaa.com`;
  }
};

export const getEndpoints = (hostname: string): Endpoints => {
  const env = getEnvironmentFromHost(hostname);
  const rootPath = '/payments-insurance-pwol/insurance-pwol/v1';

  const _endpoints: Endpoints = {
    getPolicyPaymentInfo: `https://${getApiDomain(env)}${rootPath}${endpointPath.getPolicyPaymentInfo}`,
    initializePayment: `https://${getApiDomain(env)}${rootPath}${endpointPath.initializePayment}`,
    getConfirmation: `https://${getApiDomain(env)}${rootPath}${endpointPath.getConfirmation}`,
    getTransactionStatus: `https://${getApiDomain(env)}${rootPath}${endpointPath.getTransactionStatus}`,
  };
  return _endpoints;
};

export const endpoints = getEndpoints(window.location.hostname);
